<template>
    <div class="section-posts2 section-posts-planner-view">
        <div class="navigations">
            <div class="navigation-date">
                <div class="btn-radius" @mouseenter="eventIsDrag && goToToday()" @click="goToToday">Aujourd'hui</div>
                <div class="btn-radius icon" @mouseenter="eventIsDrag && prev()" @click="prev"><i class="fa-solid fa-chevron-left"></i></div>
                <div class="btn-radius icon" @mouseenter="eventIsDrag && next()" @click="next"><i class="fa-solid fa-chevron-right"></i></div>
                <div class="date">
                    <input type="date" v-model="models.date" @click="(e)=>e.target.showPicker()" @change="setDateFromDatePiker"/>
                    <h4>{{ dateFormat }}</h4>
                    <i class="fa-solid fa-caret-down"></i>
                </div>
             
            </div>
            <div class="navigation-filter">
                <div class="btn-radius filter" :data-count="filterCount" @click.stop="filterIsOpen = true">
                    Filtrer
                    <FilterNavigation v-if="filterIsOpen" @close="filterIsOpen = false" :filter.sync="filter" @updateCalendar="refreshEvents"/>
                </div>
            
                    <ContextMenu :options="[{label: 'Partager le planner', name : 'sharePlanner'}]" :id="'ContextMenuPlanner'" v-on:clickOption="clickOption">
                        <div class="btn-radius icon">
                            <i class="fa-solid fa-ellipsis-vertical"></i>
                        </div>
                    </ContextMenu>
              
                <!-- <div class="btn-radius">Autres options</div> -->
                <div class="btn-radius icon" @click="getPlannerData(0)"><i class="fa-solid fa-rotate-right"></i></div>
            </div>
            <MainNavigation v-on="$listeners" :tabSelected="tabSelected" @switchCurrentViewType="switchCurrentViewType" :currentViewType="currentViewType"/>
        </div>
        <div class="planner" :class="[currentViewType]">
            <div class="loading-overlay" v-if="isLoading"><i class="fa-sharp fa-solid fa-spinner-third"></i>Chargement</div>
            <FullCalendar
                class='demo-app-calendar'
                :options='calendarOptions'
                ref="fullCalendar"
            >
                <!-- <template v-slot:eventContent='arg'>
                    <b>{{ arg.timeText }}</b>
                    <i>{{ arg.event.title }}</i>
                </template> -->
            </FullCalendar>
        </div>
        <template v-if="eventIsDrag">
            <div class="prevMonthHover" @mouseenter="prev"></div>
            <div class="nextMonthHover" @mouseenter="next"></div>
        </template>
        <DrawerPost 
            v-if="eventIdSelected" 
            :event="events[eventIdSelected]"
            @close="closeDrawer"
            @deletePost="handlerDeletePost"
        />
        <SharePlanner v-if="displaySharePlanner" :display="displaySharePlanner" @close="displaySharePlanner = false"/>
    </div>
 
</template>

<script>
    import Store from '@/store'
    import { EventBus } from '@/event-bus';
    import MainNavigation from './components/MainNavigation.vue'
    import Avatar from '@/components/dash/utils/avatar.vue'
    import FilterNavigation from './components/Filter.vue'
    import DrawerPost from './components/DrawerPost.vue'

    import FullCalendar from '@fullcalendar/vue'
    import dayGridPlugin from '@fullcalendar/daygrid'
    import timeGridPlugin from '@fullcalendar/timegrid'
    import interactionPlugin from '@fullcalendar/interaction'
    import frLocale from '@fullcalendar/core/locales/fr';
    import postMixins from '@/components/mixins/Posts.vue'
    import ContextMenu from '@/components/dash/contextMenu/contextMenuInit.vue'
    import plannerBehavior from './mixins/plannerBehavior.js'
    import sectionPostMixins from './mixins/main.js'
    import { getScrollTimeOfWeek } from './utils/fullcalendar'
    import SharePlanner from './components/planner/SharePlanner.vue'
    import { convertOldDraft, patchDraft } from './utils/draft.js'
    const interval = '05'

    export default {
        components: {
            MainNavigation,
            Avatar,
            FullCalendar,
            FilterNavigation,
            DrawerPost,
            ContextMenu,
            SharePlanner
        },

        mixins: [plannerBehavior, postMixins, sectionPostMixins],
        props: {
            tabSelected: String,
            defaultDate: String,
            defaultSelectedPost: Object,
        },

        data() {
            return {
                models : {
                    date : new Date().toLocaleString('fr-FR').split(' ')[0].split('/').reverse().join('-')
                },
                calendarOptions: {
                    plugins: [
                        dayGridPlugin,
                        timeGridPlugin,
                        interactionPlugin // needed for dateClick
                    ],
                    locale: 'fr',
                    locales: [frLocale],
                    
                    headerToolbar: false,
                    initialView: 'dayGridMonth',
                    //initialEvents: [], // alternatively, use the `events` setting to fetch from a feed
                    editable: true,
                    selectable: true,
                    selectMirror: true,
                    dayMaxEvents: true,
                    weekends: true,
                    slotEventOverlap: true,
                    height: '100%',
                    slotDuration: `00:${interval}:00`,
                    scrollTime: '09:00:00',
                    expandRows: false,
                    allDaySlot: false,
                    nowIndicator: true,
                    eventResizableFromStart: false, //Empêche le redimensionnement de la durée
                    eventDurationEditable: false, //Empêche l'ajout de plusieurs jours

                    select: this.handleDateSelect,
                    eventClick: this.handleEventClick,
                    eventsSet: this.handleEvents,
                    eventContent: this.renderEventContent,
                    eventClassNames: this.handlerEventClassNames,
                    moreLinkContent: this.moreLinkContent,
                    eventDragStart: this.handleDragStart, //Détection du début du drag
                    eventDragStop: this.handleDragStop, //Détection du drop (fin du déplacement)
                    dayCellDidMount: this.handleDayCellDidMount,
                    eventWillUnmount: this.handlerEventWillUnmount,
                    eventDidMount: this.handlerEventDidMount,
                    dayCellContent: this.handleDayCellContent,
                
                  
                    views: {
                        timeGridWeek: {
                            dayHeaderFormat: { weekday: 'short', day: 'numeric', omitCommas: true },
                        },
                        dayGridMonth : {
                            dayHeaderFormat: { weekday: 'short'},
                        }
                    },

                },
                currentEvents: [],
                currentDate: null,
                currentViewType: localStorage.getItem('planner/currentViewType') || 'dayGridMonth',
                eventIsDrag: false,
                lastEventDraged: null,
                events : {},

                eventsHistory :{
                    'prev': null,
                    'next': null
                },

                moreContentGridWeek : {
                    isOpen: false,
                    date: null
                },

                isLoading: false,

                timeoutGetPlannerData: null,
                lastTimeGetPlannerData: null,

                eventIdSelected : null,
                filterIsOpen: false,
                filter: {
                    search: '',
                    statusDisplay:  {
                        scheduled: true,
                        posted: true,
                        draft: true,
                        pending: true,
                        failed: true,
                        removed: true,
                        standby: true,
                        awaiting_approval: true,
                        to_validate: true,
                    },
                    typesDisplay:  {
                        carousel: true,
                        document: true,
                        reel: true,
                        video: true,
                        image: true,
                        story: true,
                    },
                },
                eventsAddAfterLoading: [],
                displaySharePlanner: false
            }
        },

        mounted () {
            if (this.$refs.fullCalendar) {
                const calendarApi = this.$refs.fullCalendar.getApi();
                this.currentDate = calendarApi.getDate()
                console.log(" this.currentDate", this.currentDate)
                if (this.defaultDate) {
                    this.currentDate = new Date(this.defaultDate)
                    const dateFormat = this.currentDate.toLocaleString('fr-FR').split(' ')[0].split('/').reverse().join('-')
                    this.models.date = dateFormat
                    calendarApi.gotoDate(dateFormat)
                }
                // this.currentViewType = calendarApi.view.type
                calendarApi.changeView(this.currentViewType)
                this.getPlannerData(0)
            }

            if (localStorage.getItem("filterPlanner")) {
                this.filter = JSON.parse(localStorage.getItem("filterPlanner"))
            }

            EventBus.$on('planner/refresh', this.getPlannerData);
        },

        methods: {
            async getPlannerData(msTimeout = 1000) {
                if (this.timeoutGetPlannerData) clearTimeout(this.timeoutGetPlannerData)

                const time = Date.now()
                this.lastTimeGetPlannerData = time
                this.isLoading = true

                this.timeoutGetPlannerData = setTimeout(async () => {
                
                    //si month alors prendre 3 mois (3 request)
                    //si week alors prendre 3 semaine (3 request)
                    //ajouter un timeout pour si il appui plein de fois sur suivant attendre 1s

                    const calendarApi = this.$refs.fullCalendar.getApi(); // Accès à l'instance de FullCalendar
                    const view = calendarApi.view;
                    const currentStart =  view.currentStart.toISOString()
                    const currentEnd =  view.currentEnd.toISOString()

                    const {body} = await this.postsByPages(
                        this.pagesSelected.map(p=>p.id).join(','), 
                        1000, 
                        currentStart, 
                        currentEnd, 
                        false, 
                        false, 
                        false
                    )

                    if (this.lastTimeGetPlannerData == time && body.success) {
                     
                        this.events = {}
                        
                        for (const post of body.posts) {
                            const event = await this.buildEvent(post);
                            if (!this.$store.getters['planner/staticEvents'][event.id]) {
                                if (event) {
                                    let storification = null

                                    //storification planifier ?
                                    if (event.originalPost.page[0].storification && event.originalPost.page[0].story) {
                                        storification = true
                                    }
                                 
                                   if (!storification) this.events[event.id] = event;


                                    //storifcation into draft?
                                 
                                    if (event.page.network == "instagram" && event.status == "draft") {
                                        if (event.draft.saveAllFormData && event.draft.tab !== 'story') {

                                            try {
                                                storification = event.draft.saveAllFormData.pages[event.page.id].formDataNetwork.instagram.storification.active
                                            } catch (error) {}
                                            
                                            if (storification !== false) {
                                                try {
                                                    storification = event.draft.saveAllFormData.networks["instagram"].formDataNetwork.instagram.storification.active
                                                } catch (error) {}
                                            }
        
                                            if (storification !== false) {
                                                try {
                                                    storification = event.draft.saveAllFormData.main.formDataNetwork.instagram.storification.active
                                                } catch (error) {}
                                            }
                                        }
                                    }
    
                                    if (storification) {
                                        console.log('trouvé storification')
                                        const eventStorification = {...event}
                                        eventStorification.id = eventStorification.id + "_storification"
                                        eventStorification.type = 'story'
                                        eventStorification.content = 'Storification'
                                        this.events[eventStorification.id] = eventStorification;   
                                    }

                                    //storifcation facebook into draft ?
                                    if (storification && event.page.network == "instagram" && event.status == "draft") {
                                        let storificationFacebook = null
                                        try {
                                            storificationFacebook = event.draft.saveAllFormData.pages[event.page.id].formDataNetwork.instagram.storification.shareInFacebook
                                        } catch (error) {}
                                        
                                        if (storificationFacebook !== false) {
                                            try {
                                                storificationFacebook = event.draft.saveAllFormData.networks["instagram"].formDataNetwork.instagram.storification.shareInFacebook
                                            } catch (error) {}
                                        }
    
                                        if (storificationFacebook !== false) {
                                            try {
                                                storificationFacebook = event.draft.saveAllFormData.main.formDataNetwork.instagram.storification.shareInFacebook
                                            } catch (error) {}
                                        }
                                        console.log('trouvé storification facebook', storificationFacebook)
                                        if (storificationFacebook) {
                                            const page = this.allPages[event.page.id]
                                            console.log("page",page)
                                            if (page.affected_to) {
                                                const pageFacebook = this.pagesSelected.find(p => p.network_id && p.network_id == page.affected_to)

                                                if (pageFacebook) {
                                                    const eventStorification = {...event}
                                                    eventStorification.page = {
                                                        avatar: page.avatar,
                                                        id: event.page.id,
                                                        network:"facebook",
                                                    }
                                                    eventStorification.id = eventStorification.id + "_facebook_storification"
                                                    eventStorification.type = 'story'
                                                    eventStorification.content = 'Storification'
                                                    this.events[eventStorification.id] = eventStorification;   
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        if (this.eventsAddAfterLoading.length) {
                            for (const event of this.eventsAddAfterLoading) {
                                this.events[event.id] = event;
                            }
                            this.eventsAddAfterLoading = []
                        }

                        this.events = {
                            ...this.events,
                            ...this.$store.getters['planner/staticEvents']
                        }

                        console.log('clem43 load curent',this.events)
                        this.refreshEvents()
                        this.$nextTick(()=>{
                            calendarApi.scrollToTime(getScrollTimeOfWeek(calendarApi, calendarApi.getEvents()))
                            calendarApi.render()
                        })
                        this.isLoading = false

                        ///////////////////// preload data ////////////////////////

                        let date;
            
                        if (!this.eventsHistory.next) {
                            date = new Date(view.currentEnd)
                            if (view.type == "dayGridMonth") date.setMonth(date.getMonth()+1) 
                            else date.setDate(date.getDate() + 7);

                            const {body:bodyNext} = await this.postsByPages(this.pagesSelected.map(p=>p.id).join(','), 1000, currentEnd, date.toISOString(), false, false, true)

                            if (this.lastTimeGetPlannerData !== time) return

                            if (bodyNext.success) {
                                this.eventsHistory.next = {}
                                bodyNext.posts.forEach(post => {
                                    let event = this.buildEvent(post)
                                    if (event) this.eventsHistory.next[event.id] = event
                                });
                            }
                            console.log('clem43 load next',this.eventsHistory.next)
                        }

                        if (!this.eventsHistory.prev) {
                            console.log('clem43 load prev')
                            date = new Date(view.currentStart)

                            if (view.type == "dayGridMonth") date.setMonth(date.getMonth()-1)
                            else date.setDate(date.getDate() - 7);

                            const {body:bodyPrev} = await this.postsByPages(this.pagesSelected.map(p=>p.id).join(','), 1000, date.toISOString(), currentStart, false, false, true)
                            if (this.lastTimeGetPlannerData !== time) return
                                
                            if (bodyPrev.success) {
                                this.eventsHistory.prev = {}
                                bodyPrev.posts.forEach(post => {
                                    let event = this.buildEvent(post)
                                    if (event) this.eventsHistory.prev[event.id] = event
                                });
                            }
                            console.log('clem43 load prev',this.eventsHistory.prev)
                        }

                        console.log("getPlannerData event",Object.values(this.events).length)
                    }

                }, msTimeout);
            },

            async changeDatePost(eventId, date, all= null, allStorification	= false) {
                
                const event = this.events[eventId] || (this.lastEventDraged.id == eventId && this.lastEventDraged)
                
                console.log('changeDatePost event', event, date, eventId)

                const isPostsMultipaged = this.isPostsMultipaged(event.originalPost)             
                if (all == null) {
                    if (isPostsMultipaged) {
                        EventBus.$emit("showModal", 
                            "Attention", 
                            "Ce post a été poussé sur plusieurs pages. Souhaitez-vous modifier la date à l'ensemble des posts ? ", 
                            "Tous les posts", 
                            "Ce post uniquement",  
                            ()=>{
                                this.changeDatePost(eventId, date, true)
                            },
                            ()=>{
                                this.changeDatePost(eventId, date, false)
                            },
                        );
                        return
                    }else{
                        all = false
                    }
                }

                
                if (!all) {
                    let dateStorifcation = null
                    let datePostWithStorification = null

                    if (eventId.endsWith('_storification')) {
                        datePostWithStorification = new Date(this.events[eventId.replace('_storification', '')].date)
                        dateStorifcation = date
                    }else if (this.events[eventId + '_storification']){
                        datePostWithStorification = date
                        dateStorifcation = new Date(this.events[eventId + '_storification'].date)
                    }

                    if (datePostWithStorification && dateStorifcation) {
                        if (datePostWithStorification > dateStorifcation) {
                            allStorification = true
                        }
                    }
                }

                if (!this.events[eventId]) {
                    this.events[eventId] = this.lastEventDraged
                    this.refreshEvents()
                }

                const calendarApi = this.$refs.fullCalendar.getApi();

                let events = [event]

                if (isPostsMultipaged && all == true) {
                    if (event.status == "draft") {
                        events = event.originalPost.draft.data.pages.reduce((acc, pageId) => {
                            if (this.events[event.originalPost.id + pageId]) acc.push(this.events[event.originalPost.id + pageId])
                            return acc
                        }, [])
                    }else{
                        events = event.originalPost.page[0].posts_multipages.reduce((acc, {_id, page:pageId}) => {
                            if (this.events[_id + pageId]) acc.push(this.events[_id + pageId])
                            return acc
                        }, [])
                    }
                }

              
                const dateString = date.toISOString()
                
                calendarApi.batchRendering(() => {
                    events.forEach((event) => {
                        //update data event
                        event.loading = true
                        event.date = dateString
                        //event.originalPost.page[0].scheduled_date = dateString

                        const eventInstance = calendarApi.getEventById(event.id);
                        if (eventInstance) {
                            eventInstance.setExtendedProp('loading', true);
                            //eventInstance.setDates(new Date(dateString))
                        }
                        this.events[event.id] = event
                    });
                })

                if (this.isLoading) {
                    this.eventsAddAfterLoading = events
                }

                const saveDraft = event.status == 'draft' ? JSON.stringify(event.originalPost.draft.data) : event.originalPost.page[0].draft
                let draft = JSON.parse(saveDraft)
                
                if (!draft.saveAllFormData) {
                    const pages =  event.originalPost.page && event.originalPost.page[0].posts_multipages ? 
                        event.originalPost.page[0].posts_multipages.map(({page}) => page) : 
                        [event.page.id]
                    draft = convertOldDraft(draft, pages)
                }

                //update draft
                if (draft.saveAllFormData) {
                    draft = patchDraft(draft)
                    const hours = date.getHours().toString().padStart(2, '0');
                    const minutes = date.getMinutes().toString().padStart(2, '0');
                    const formattedHours = `${hours}:${minutes}`;
                    const formattedDate = date.toISOString().split('T')[0];
                    
                    if (all == false && isPostsMultipaged) {
                        if (!draft.saveAllFormData.pages[event.page.id]) draft.saveAllFormData.pages[event.page.id] = {}
                        draft.saveAllFormData.pages[event.page.id].planifiedDate = {
                            date: formattedDate,
                            hours: formattedHours,
                            timestamp: date.getTime()
                        }

                    }else{
                        draft.saveAllFormData.main.planifiedDate = {
                            date: formattedDate,
                            hours: formattedHours,
                            timestamp: date.getTime()
                        }
                        for (const [networkName, formData] of Object.entries(draft.saveAllFormData.networks)) {
                            if (formData.planifiedDate) {
                                delete formData.planifiedDate
                            }
                        }

                        for (const [pageId, formData] of Object.entries(draft.saveAllFormData.pages)) {
                            if (formData.planifiedDate) {
                                delete formData.planifiedDate
                            }
                        }
                    }
                }
                
                if (event.status == 'draft') {
                    event.originalPost.draft.data = draft
                }else{
                    event.originalPost.page[0].draft = JSON.stringify(draft)
                }
              
                try {
                    console.log("updatePostScheduledDate", event.originalPost,{
                        date: dateString,
                        hour: date.getHours(), 
                        minute: date.getMinutes(), 
                        scheduledDate: dateString,
                    })

                    const dateTest = new Date(dateString)
                    dateTest.setHours(0,0,0,0) 
                    dateTest.setHours(3) 
                    const {body} = await this.updatePostScheduledDate(event.originalPost, {
                        date: dateTest.toISOString(),//dateString,
                        hour: date.getHours(), 
                        minute: date.getMinutes(), 
                        scheduledDate: dateString,
                    }, all, allStorification);

                    if (body.success) {
                      
                        //update data event
                        calendarApi.batchRendering(() => {
                            events.forEach(({id:eventId}) => {
                                if (this.events[eventId]) {
                                    this.events[eventId].loading = false
                                    this.events[eventId].draft = draft   
                                }
                                const eventInstance = calendarApi.getEventById(eventId);
                                if (eventInstance) eventInstance.setExtendedProp('loading', false);            
                           
                            });
                        })
                    }else{
                       throw new Error("Error updatePostScheduledDate");
                    }
                } catch (error) {
                    console.error(error)
                    if (event.status == 'draft') {
                        event.originalPost.draft.data = JSON.parse(saveDraft)
                    }else{
                        event.originalPost.page[0].draft = saveDraft
                    }

                    eventsAddAfterLoading = []

                    calendarApi.batchRendering(() => {
                        events.forEach(({id: eventId}) => {
                            if (this.events[eventId]) {
                                this.events[eventId].loading = false
                                this.events[eventId].date = dateString
                                this.events[eventId].originalPost.page[0].scheduled_date = dateString
                            }

                            //update data event
                            const eventInstance = calendarApi.getEventById(eventId);
                            if (eventInstance) {
                                eventInstance.setExtendedProp('loading', true);
                                eventInstance.setDates(dateString, dateString)
                            }                           
                        });
                    })
                }

                if (all) {
                    this.getPlannerData(0)
                }
              
            },   

            closeDrawer() {
                this.eventIdSelected = null
                // this.getPlannerData()
            },

            clickOption(contextMenuId, nameOption, event) {

                switch (nameOption) {
                    case 'sharePlanner':
                        this.displaySharePlanner = true
                        break;
                    default:
                        break;
                }
            }
        },

        computed: {
            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages'];
            },
            pagesSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected'];
            },
            selectPageIsRetracted() {
                return this.$store.getters['selectPage/selectPageStateListRetracted'];
            },
            dateFormat() {
                if (this.currentDate) {
                    if (this.currentDate instanceof Date) {

                        let options = {}

                        if (this.currentViewType == 'timeGridWeek') {
                            options = {
                                day: 'numeric',
                                month: 'long',
                                year:'numeric'
                            }
                        }else{
                            options = {
                                month: 'long',
                                year:'numeric'
                            }
                        }
                        return this.currentDate.toLocaleDateString('fr-FR', options)
                    }
                }
                return undefined
            },
            filterCount() {
                return (this.filter.search ? 1 : 0) + (Object.values(this.filter.statusDisplay).includes(false) ? 1 : 0) + (Object.values(this.filter.typesDisplay).includes(false) ? 1 : 0)
            }
        },

        watch: {
            pagesSelected() {
                this.getPlannerData()
            },
            selectPageIsRetracted() {

                setTimeout(() => {
                    this.recalculateResponsive()
                }, 500);
               
            },
            currentDate() {
                this.$set(this.models, 'date', this.currentDate.toLocaleString('fr-FR').split(' ')[0].split('/').reverse().join('-'))
            },
            defaultDate() {
                if (this.defaultDate) {
                    const calendarApi = this.$refs.fullCalendar.getApi();
                    this.currentDate = new Date(this.defaultDate)
                    const dateFormat = this.currentDate.toLocaleString('fr-FR').split(' ')[0].split('/').reverse().join('-')
                    this.models.date = dateFormat
                    calendarApi.gotoDate(dateFormat)
                    this.getPlannerData(0)
                }
            },

            defaultSelectedPost: {
                immediate: true,
                async handler(newValue, oldValue) {
                    console.log('clem55 defaultSelectedPost', newValue, oldValue)
                    if (this.defaultSelectedPost) {
                        const event = await this.buildEvent(this.defaultSelectedPost);

                        //select page
                        if (!this.pagesSelected.some(p => p.id == event.page.id)) {
                            this.pagesSelected.push(this.allPages[event.page.id])
                            this.$store.commit('selectPage/updateSelectPagePageSelected', this.pagesSelected);
                        }
      
                        this.events[event.id] = event;
                        this.eventIdSelected = event.id;
                    }
                }
            }
        },

        beforeDestroy() {
            localStorage.setItem('filterPlanner',JSON.stringify(this.filter))
            EventBus.$off('planner/refresh', this.getPlannerData);
        },
    }
  
    // const calendarApi = this.$refs.fullCalendar.getApi();
    //   const currentDate = calendarApi.getDate(); // Obtient la date actuelle du calendrier
    //   this.currentMonth = currentDate.toLocaleString('fr-FR', { month: 'long', year: 'numeric' });

    // const events = calendarApi.getEvents({
    //     start: currentDate,
    //     end: new Date(currentDate.getTime() + 24 * 60 * 60 * 1000) // Ajouter 1 jour
    //   });

      
    //   const calendarApi = this.$refs.fullCalendar.getApi();
    // const events = calendarApi.getEvents();

    // refreshEvents() {
    //             const calendarApi = this.$refs.fullCalendar.getApi();
    //             calendarApi.refetchEvents();
    //         },

      /* you can update a remote database when these fire:
                    eventAdd:
                    eventChange:
                    eventRemove:
                    */
</script>

<style lang="scss" scoped>

</style>